<template>
  <div :class="_.view">
    <button @click="handleRefreshClick">刷新页面</button>
    <button @click="handleCopyLinkClick">复制当前链接</button>
    <button @click="handleCopyPClick">复制p参数</button>
    <hr />
    <h4>当前链接</h4>
    <div>{{ url }}</div>
    <div>
      <Qrcode :class="_.qrcode" :value="url" :size="100" />
    </div>
    <hr />
    <h4>CSS 变量</h4>
    <div :class="_.pre">
      {{ JSON.stringify(cssVars, null, 2) }}
    </div>
  </div>
</template>

<script>
  import Qrcode from './components/qrcode/index.vue'
  import { copyTextToClipboard } from 'vtils'
  import { dcb } from '@dcb/jssdk'
  import { getP } from './api/encrypt'
  import { Toast } from 'vant'

  // could pass in an array of specific stylesheets for optimization
  function getAllCSSVariableNames(styleSheets = document.styleSheets) {
    const cssVars = []
    // loop each stylesheet
    for (let i = 0; i < styleSheets.length; i++) {
      // loop stylesheet's cssRules
      try {
        // try/catch used because 'hasOwnProperty' doesn't work
        for (let j = 0; j < styleSheets[i].cssRules.length; j++) {
          try {
            // loop stylesheet's cssRules' style (property names)
            for (let k = 0; k < styleSheets[i].cssRules[j].style.length; k++) {
              const name = styleSheets[i].cssRules[j].style[k]
              // test name for css variable signiture and uniqueness
              if (name.startsWith('--') && cssVars.indexOf(name) === -1) {
                cssVars.push(name)
              }
            }
          } catch (error) {}
        }
      } catch (error) {}
    }
    return cssVars
  }

  function getElementCSSVariables(allCSSVars, element = document.body, pseudo) {
    const elStyles = window.getComputedStyle(element, pseudo)
    const cssVars = {}
    for (let i = 0; i < allCSSVars.length; i++) {
      const key = allCSSVars[i]
      const value = elStyles.getPropertyValue(key)
      if (value) {
        cssVars[key] = value
      }
    }
    return cssVars
  }

  export default {
    components: {
      Qrcode,
    },

    data: () => ({
      url: location.href,
      cssVars: {},
    }),

    watch: {
      $route: {
        immediate: true,
        handler() {
          this.url = location.href
          const cssVars = getAllCSSVariableNames()
          this.cssVars = getElementCSSVariables(
            cssVars,
            document.documentElement,
          )
        },
      },
    },

    mounted() {
      this.$emit('ready')
    },

    methods: {
      handleRefreshClick() {
        dcb.navigateTo({
          url: location.href,
        })
        setTimeout(() => {
          dcb.closeWindow()
        }, 0)
      },

      handleCopyLinkClick() {
        copyTextToClipboard(location.href)
        Toast.success({
          message: '复制成功',
          className: this._.toast,
        })
      },

      handleCopyPClick() {
        copyTextToClipboard(getP())
        Toast.success({
          message: '复制成功',
          className: this._.toast,
        })
      },
    },
  }
</script>

<style lang="scss" module="_">
  .view {
    padding: 12px;
    margin-top: -12px;

    > * {
      margin-right: 12px;
      margin-top: 12px;
      font-size: 18px;
    }
  }

  .toast {
    z-index: 99999 !important;
  }

  .pre {
    white-space: pre-wrap;
    font-size: 14px;
  }

  .qrcode {
    width: 100px;
    height: 100px;
  }
</style>
